import styled from 'styled-components';

export const LegendList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  width: 100%;
`;

export const LegendRow = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 12px;
`;

export const LegendDot = styled.div`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  margin-top: 6px;

  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

export const LegendTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`;

export const LegendLabel = styled.div`
  font: ${({ font }) => font};
  color: ${({ color }) => color};
`;

export const LegendDescription = styled.div`
  font: ${({ font }) => font};
  color: ${({ color }) => color};
`;
